/**
 * Return an array of elements
 **/
export function getAllArray (selector, parent) {
  parent = parent || document
  return Array.prototype.slice.call(parent.querySelectorAll(selector))
}

/**
 * Attach a click event to a class
 * similar to jQuery's $('.element').click(function(event) {});
 **/
export function clickEvent (selector, callback) {
  const elements = getAllArray(selector)
  elements.forEach(element => {
    element.addEventListener('click', callback)
  })
}

/**
 * Viewport size
 */
export let windowWidth = getWindowWidth()
export let windowHeight = getWindowHeight()

function getWindowWidth () {
  return (
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.getElementsByTagName('body')[0].clientWidth
  )
}

function getWindowHeight () {
  return (
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('body')[0].clientHeight
  )
}

export function attachViewportSizeListeners () {
  window.addEventListener('resize', () => {
    windowWidth = getWindowWidth()
    windowHeight = getWindowHeight()
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/core/helpers.js